<template>
    <div class="create-goods">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>公司介绍</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem; background-color: white">
            <el-form ref="form" :rules="rules"  :model="form" label-width="180px">
                <el-form-item label="创建人" prop="creator">
                    <el-col :span="24">
                        {{form.creator}}
                    </el-col>
                </el-form-item>
                <el-form-item label="创建时间" prop="createTime">
                    <el-col :span="10">
                        {{form.createTime}}
                    </el-col>
                </el-form-item>
                <el-form-item label="上次更新人" prop="updator">
                    <el-col :span="10">
                        {{form.updator}}
                    </el-col>
                </el-form-item>
                <el-form-item label="上次更新时间" prop="updateTime">
                    <el-col :span="20">
                        {{form.updateTime}}
                    </el-col>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <el-col :span="20">
                        <Editor id="tiny" v-model="form.content" />
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                    <el-button @click="$router.back()">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import Editor from "../../components/tinymce"
    import articleApi from "../../api/article";
    export default {
        data: function () {
            return {
                form: {
                    content: ""
                },
                rules: {

                },
            }
        },
        mounted: function() {
            this.loadContent();
        },
        components: {Editor},
        methods: {
            loadContent: function() {
                articleApi.getByType("ci").then(result => {
                    this.form = result;
            })
            },
            onSubmit: function () {
                this.$refs["form"].validate(valid => {
                    if(!valid) return;
                    const loading = this.$loading({
                        lock: true,
                        text: '保存中',
                        spinner: 'el-icon-loading',
                    });
                    articleApi.save(this.form).then(result => {
                        loading.close();
                        this.loadContent();
                        this.$message({
                            type: 'success',
                            message: '保存成功!'
                        });
                    })
                })

            },
        }
    }
</script>
<style lang="less">
    .standards {
        .add-standard {
            color: #1c6ca1;
            cursor: pointer;
        }
    }
</style>
